import { faAngleRight } from "@jewlr/pro-light-svg-icons/faAngleRight"
import {
  Box,
  Flex,
  FontAwesomeIcon,
  Image,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { deactivateSubmenu } from "app-store-v2/app/actions"
import useNavigation from "helpers/use-navigation"

const DropdownWrap = styled(Flex).attrs((props) => ({
  containWide: true,
  display: "grid",
  gridTemplateColumns: "repeat(5, 1fr)",
  minHeight: "340px",
  pad: true,
  ...props,
}))`
  justify-content: space-between;
`
const NavCol = styled(Box)`
  border-left: 1px solid ${(props) => props.theme.colors.grey[10]};
  display: flex;
  flex-direction: column;
  margin: 35px 0;
  min-width: 16%;
  padding-left: 25px;
  padding-right: 10px;
  &:first-child {
    border-left: none;
    padding-left: 10px;
  }
`
const NavColTitle = styled(Typography).attrs({
  color: "black",
  fontSize: "16px",
  mb: "10px",
})`
  font-weight: normal;
  min-height: 20px;
  text-transform: uppercase;
`
const NavList = styled(Box).attrs({
  as: "ul",
})`
  list-style: none;
  margin: 0;
  padding: 0;
`
const NavLink = styled(Typography).attrs({
  as: Link,
  fontSize: "14px",
  ml: "8px",
})`
  display: inline-block;
  min-width: 10px;
  letter-spacing: 0.5px;
  padding: 5px 0;
  text-transform: capitalize;
  &:focus-visible,
  &:hover {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }
`
const PromoCol = styled(Box).attrs((props) => ({
  as: Link,
  mb: 2,
  mt: "35px",
  ...props,
}))`
  cursor: pointer;
  text-align: center;
  ${(props) =>
    props.$promoOnly &&
    `
    display: flex;
    flex-direction: column;
    jusitfy-content: center;
    padding: 10px;
    :focus {
      opacity: 0.6;
    }
  `}
  &:focus-visible p,
  &:hover p {
    color: ${(props) => props.theme.colors.primary};
    text-decoration: underline;
  }
`
const PromoImg = styled(Image)`
  margin: 0 auto 16px;
  width: 225px;
`

const InternalDropdownContent = ({
  dropdownColNum,
  dropdownMenu,
  leftMenu,
}) => {
  const keyboardProps = useNavigation({
    direction: "both",
    onEscape: () => leftMenu(),
  })

  return (
    <DropdownWrap {...keyboardProps}>
      {dropdownMenu.sections &&
        dropdownMenu.sections.map((section, index) => (
          <NavCol key={"d" + index} {...section.style?.colStyle}>
            <NavColTitle
              aria-label={`${dropdownMenu.name} ${section.title}`}
              as="h3"
              id={`nav_col_${section.title}`}
            >
              {section.title}
            </NavColTitle>
            <NavList aria-labelledby={`nav_col_${section.title}`} role="menu">
              {section.links
                .filter(
                  (link) => typeof link.show === "undefined" || !!link.show
                )
                .map((link, j) => (
                  <li key={"l" + j} role="none">
                    <NavLink
                      data-cy={`header-menu-dropdown-${link.name}-desktop`}
                      data-lc="menu"
                      role="menuitem"
                      to={link.url}
                      {...link.style}
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: link.name,
                        }}
                      />{" "}
                      {link.is_new && (
                        <Typography as="span" color="sale" ml="4px">
                          New!
                        </Typography>
                      )}
                    </NavLink>
                  </li>
                ))}
            </NavList>
          </NavCol>
        ))}
      {dropdownMenu.images &&
        dropdownMenu.images.map((image, index) => (
          <PromoCol
            $promoOnly={!dropdownMenu.categories}
            data-lc="menu"
            display={
              dropdownColNum + index > 4
                ? { desktop: "block", tablet: "none" }
                : {}
            }
            key={"d" + index}
            role="menuitem"
            to={image.url}
          >
            <PromoImg
              alt={image.alt}
              fallback={image.fallback}
              ratio="auto 865 / 905"
              srcSet={image.srcSet}
            />
            {!!image.title && (
              <Typography
                alignItems="center"
                display="flex"
                fontSize="14px"
                fontWeight="400"
                justifyContent="center"
              >
                <FontAwesomeIcon icon={faAngleRight} mr={1} width="6px" />
                {image.title}
              </Typography>
            )}
          </PromoCol>
        ))}
    </DropdownWrap>
  )
}

InternalDropdownContent.propTypes = {
  dropdownColNum: PropTypes.number,
  dropdownMenu: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  leftMenu: PropTypes.func,
}

const getColNum = (state) => {
  const content = state.menu.submenu
  if (content) {
    return Object.keys(content).length
  }
  return 0
}

const mapStateToProps = (state, ownProps) => {
  return {
    dropdownColNum: getColNum(state, ownProps),
    dropdownMenu: state.menu.desktopSubmenu,
  }
}

const mapDispatchToProps = (dispatch) => ({
  leftMenu: () => dispatch(deactivateSubmenu()),
})

const DropdownContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalDropdownContent)

export default DropdownContent
